/* 15 Oct (Claude): adds the "Size chart" link to the quick "Choose options" pop-up on collection pages.
   4 Nov: dog hoodies now show their own table with breed examples, no laid-flat wording and no human tip. Undo: re-save the previous version or remove the qo-sizechart line in snippets/meta-tags.liquid. */
(function () {
  'use strict';
  if (window.__swwQoSc) return;
  window.__swwQoSc = true;
  var cache = {};
  var css = document.createElement('style');
  css.textContent =
    '.sww-qo-scrow{display:flex;justify-content:flex-end;margin:0 0 -22px;position:relative;z-index:1}' +
    '.sww-qo-sclink{display:inline-flex;align-items:center;gap:6px;background:none;border:0;padding:2px 0;color:#1f4d3a;font:inherit;font-size:14px;font-weight:600;text-decoration:underline;text-underline-offset:3px;cursor:pointer}' +
    '.sww-qo-sclink svg{width:18px;height:18px;flex:0 0 18px}' +
    '.sww-qo-dlg{width:min(560px,calc(100vw - 24px));max-height:calc(100vh - 48px);padding:0;border:0;border-radius:16px;background:#fff;color:#111;box-shadow:0 20px 60px rgba(0,0,0,.25)}' +
    '.sww-qo-dlg::backdrop{background:rgba(0,0,0,.45)}' +
    '.sww-qo-dlg .h{display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-bottom:1px solid #e6e2da}' +
    '.sww-qo-dlg .h h2{margin:0;font-size:18px;font-weight:700}' +
    '.sww-qo-dlg .x{width:40px;height:40px;border:0;border-radius:50%;background:#f3efe8;font-size:22px;line-height:1;cursor:pointer;color:#111}' +
    '.sww-qo-dlg .b{padding:12px 14px 18px;font-size:14px;line-height:1.55}' +
    '.sww-qo-dlg .s{overflow-x:auto;margin:0 0 10px}' +
    '.sww-qo-dlg table{table-layout:auto;width:auto;min-width:100%;border-collapse:collapse;margin:0}' +
    '.sww-qo-dlg th,.sww-qo-dlg td{color:#111;background:#fff;padding:7px 6px;border:1px solid #e6e2da;text-align:center;white-space:nowrap;font-size:13px}' +
    '.sww-qo-dlg tr:first-child th,.sww-qo-dlg tr:first-child td,.sww-qo-dlg th:first-child,.sww-qo-dlg td:first-child{background:#f6f3ee;font-weight:600}' +
    '.sww-qo-hd th,.sww-qo-hd td{white-space:normal;font-size:12px;padding:6px 4px;line-height:1.35}' +
    '.sww-qo-hd th:last-child,.sww-qo-hd td:last-child{min-width:120px;text-align:left}' +
    '.sww-qo-dlg .n{margin:6px 0 0;color:#444}' +
    '.sww-qo-dlg .w{margin:10px 0 0;padding:10px 12px;border-radius:10px;background:#f6f3ee}';
  document.head.appendChild(css);

  var RULER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="2" y="7" width="20" height="10" rx="1.5"/><path d="M6 7v4M10 7v3M14 7v4M18 7v3"/></svg>';
  var BREEDS = { 'XS': 'Chihuahua, Yorkshire Terrier, Toy Poodle', 'S': 'Miniature Dachshund, Pomeranian, Maltese', 'M': 'Shih Tzu, Jack Russell Terrier, Pug', 'L': 'Cavalier King Charles Spaniel, Border Terrier, French Bulldog', 'XL': 'Cocker Spaniel, Beagle, Whippet', '2XL': 'Staffordshire Bull Terrier, English Springer Spaniel, Border Collie' };
  function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function isHoodie(p) { return /hoodie/i.test((p && p.type) || ''); }
  function isSizeTable(t, p) {
    var s = txt(t).toLowerCase();
    if (/^spec/.test(s)) return false;
    if (/typical breeds/.test(s) && !isHoodie(p)) return false;
    if (!/(chest|width|length|waist|neck|back|weight|dimension|capacity|height)/.test(s)) return false;
    return /\d/.test(s);
  }
  function addBreeds(t) {
    var s = txt(t);
    if (/typical breeds/i.test(s) || !/all the way round/i.test(s)) return;
    [].slice.call(t.rows).forEach(function (r, i) {
      var c = document.createElement(i === 0 ? 'th' : 'td');
      c.textContent = i === 0 ? 'Typical breeds' : (BREEDS[txt(r.cells[0])] || '');
      r.appendChild(c);
    });
  }
  function relabel(t) {
    [].slice.call(t.querySelectorAll('th,td')).forEach(function (c) {
      if (!/^chest\b/i.test(txt(c)) || /width|flat|circ|round/i.test(txt(c))) return;
      var row = c.parentNode, nums = [].slice.call(row.cells).slice(1).map(function (x) { return parseFloat(txt(x)); }).filter(function (x) { return !isNaN(x); });
      if (!nums.length && row.rowIndex === 0) {
        var ci = c.cellIndex;
        nums = [].slice.call(t.rows).slice(1).map(function (r) { return parseFloat(txt(r.cells[ci] || { textContent: '' })); }).filter(function (x) { return !isNaN(x); });
      }
      if (!nums.length) return;
      nums.sort(function (a, b) { return a - b; });
      var mid = nums[Math.floor(nums.length / 2)];
      if (mid < 75) c.textContent = txt(c).replace(/^chest/i, 'Chest width (laid flat)');
    });
  }
  function getProduct(url) {
    var handle = (url.split('/products/')[1] || '').split(/[?#]/)[0];
    if (!handle) return Promise.resolve(null);
    if (!cache[handle]) cache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[handle];
  }
  function openChart(p, table) {
    var hood = isHoodie(p);
    var d = document.createElement('dialog');
    d.className = 'sww-qo-dlg' + (hood ? ' sww-qo-hd' : '');
    d.innerHTML = '<div class="h"><h2>Size chart</h2><button type="button" class="x" aria-label="Close size chart">&times;</button></div><div class="b"><div class="s"></div></div>';
    var copy = table.cloneNode(true);
    copy.removeAttribute('style');
    [].slice.call(copy.querySelectorAll('[style],[class],[width],[bgcolor]')).forEach(function (e) { e.removeAttribute('style'); e.removeAttribute('class'); e.removeAttribute('width'); e.removeAttribute('bgcolor'); });
    if (hood) addBreeds(copy); else relabel(copy);
    d.querySelector('.s').appendChild(copy);
    var b = d.querySelector('.b');
    var n = document.createElement('p'); n.className = 'n';
    if (hood) n.textContent = 'These are the measurements of the hoodie itself. Measure your dog all the way round the chest (widest part, just behind the front legs), then choose a size slightly bigger. Breeds are a guide only. If your dog is between sizes, go up a size.';
    else n.textContent = /width|flat/i.test(txt(copy)) ? 'Width is measured flat across the chest, armpit to armpit. Length is measured from the top of the shoulder to the hem. Measurements can vary by about 2-3 cm.' : 'Measurements are approximate and can vary slightly.';
    b.appendChild(n);
    if (hood) {
      var w2 = document.createElement('p'); w2.className = 'w';
      w2.textContent = 'Made to order, so we cannot swap sizes after ordering. If in doubt, go up a size.';
      b.appendChild(w2);
    } else if (/t-?shirt|tee|sweatshirt/i.test(p.type || '')) {
      var w = document.createElement('p'); w.className = 'w';
      w.textContent = "Tip: lay a top that fits you well flat and measure it, then pick the closest size. As this is made to order, we can't swap sizes after ordering.";
      b.appendChild(w);
    }
    document.body.appendChild(d);
    function close() { d.close(); d.remove(); }
    d.querySelector('.x').addEventListener('click', close);
    d.addEventListener('click', function (e) { if (e.target === d) close(); });
    d.addEventListener('cancel', function () { setTimeout(function () { d.remove(); }, 0); });
    if (d.showModal) d.showModal(); else d.setAttribute('open', '');
  }
  function enhance(info) {
    var more = info.querySelector('a[href*="/products/"]') || (info.closest('.sww-qo') || document).querySelector('.sww-qo__more');
    if (!more) return;
    var fs = [].slice.call(info.querySelectorAll('fieldset')).filter(function (f) {
      var l = f.querySelector('legend'); return l && /^\s*sizes?\b/i.test(txt(l));
    })[0];
    if (!fs || (fs.previousElementSibling && fs.previousElementSibling.classList.contains('sww-qo-scrow'))) return;
    var url = more.getAttribute('href');
    if (info.dataset.swwScFor === url + '|none') return;
    getProduct(url).then(function (p) {
      if (!p || !p.description) { info.dataset.swwScFor = url + '|none'; return; }
      var box = document.createElement('div');
      box.innerHTML = p.description;
      var table = [].slice.call(box.querySelectorAll('table')).filter(function (t) { return isSizeTable(t, p); })[0];
      if (!table) { info.dataset.swwScFor = url + '|none'; return; }
      if (fs.previousElementSibling && fs.previousElementSibling.classList.contains('sww-qo-scrow')) return;
      var row = document.createElement('div');
      row.className = 'sww-qo-scrow';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sww-qo-sclink';
      btn.innerHTML = RULER + '<span>Size chart</span>';
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openChart(p, table); });
      row.appendChild(btn);
      fs.parentNode.insertBefore(row, fs);
    });
  }
  var t;
  function scan() {
    clearTimeout(t);
    t = setTimeout(function () {
      [].forEach.call(document.querySelectorAll('.sww-qo__info'), function (info) { try { enhance(info); } catch (e) {} });
    }, 80);
  }
  if (window.MutationObserver) new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
